var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 Z M16,31 C24.2842712,31 31,24.2842712 31,16 C31,7.71572875 24.2842712,1 16,1 C7.71572875,1 1,7.71572875 1,16 C1,24.2842712 7.71572875,31 16,31 Z M15.9950914,6 C21.5161804,6 25.9928597,10.4766793 25.9883964,16.0022316 C25.9883964,21.5233207 21.5117171,26 15.9906281,26 C15.0042411,26 14.0535605,25.8527114 13.1564393,25.5893774 C13.5358189,24.9868333 13.9509048,24.2191475 14.1606794,23.4469984 C14.2856515,23.0006695 14.8658792,20.6976121 14.8658792,20.6976121 C15.2140157,21.358179 16.2271824,21.9428699 17.3072985,21.9428699 C20.5208669,21.9428699 22.7034154,19.014952 22.7034154,15.0917206 C22.7034154,12.1280964 20.1905835,9.36532024 16.374471,9.36532024 C11.625531,9.36532024 9.22874458,12.7708101 9.22874458,15.6094622 C9.22874458,17.3322919 9.88038484,18.8587369 11.2773944,19.4300379 C11.5050222,19.523767 11.7103335,19.4345012 11.7772829,19.1800937 C11.826379,19.0015622 11.933498,18.5596965 11.9825942,18.3767016 C12.0495435,18.1267574 12.0227638,18.0374916 11.8397689,17.8187904 C11.4380729,17.3456818 11.1792021,16.7297478 11.1792021,15.8594064 C11.1792021,13.3331846 13.0716368,11.0702968 16.1022103,11.0702968 C18.7846473,11.0702968 20.2619961,12.708324 20.2619961,14.8997992 C20.2619961,17.7830841 18.9854953,20.2155769 17.0930606,20.2155769 C16.0441876,20.2155769 15.2631119,19.354162 15.5130561,18.2918991 C15.8120965,17.0243249 16.3967874,15.6585584 16.3967874,14.743584 C16.3967874,13.9268021 15.9593851,13.2439188 15.048874,13.2439188 C13.9776846,13.2439188 13.120733,14.3508146 13.120733,15.8326266 C13.120733,16.7743807 13.4420898,17.4126311 13.4420898,17.4126311 C13.4420898,17.4126311 12.3485839,22.0499888 12.1566625,22.8623075 C11.9781309,23.6210667 11.9558144,24.4601651 11.9825942,25.1564383 C8.4610588,23.6076769 5.99732303,20.0906048 5.99732303,15.9977684 C5.99732303,10.4766793 10.4740023,6 15.9950914,6 Z",
    id: "path-1-pinterest"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-pinterest",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFP-Imagery-pinterest",
    transform: "translate(-414.000000, -421.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/32px/Social/Pinterest",
    transform: "translate(414.000000, 421.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "COLOR/-black-pinterest"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-pinterest",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-pinterest"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "COLOR/-Gray-pinterest",
    mask: "url(#mask-2-pinterest)",
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-pinterest",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/Pinterest.e110880b600917b7ea8c0d45e71f8f78.svg";
export { ForwardRef as ReactComponent };